import React from "react";

interface RedFlagIconProps {
  width?: number;
  height?: number;
}

export const RedFlagIcon: React.FC<RedFlagIconProps> = ({
  width = 20,
  height = 20,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1 8.4C9.21927 8.39994 9.33655 8.3694 9.44071 8.31128C9.54487 8.25316 9.63245 8.16939 9.69514 8.06792C9.75783 7.96645 9.79355 7.85065 9.79892 7.7315C9.80428 7.61234 9.77911 7.49379 9.7258 7.3871L8.4826 4.9L9.7258 2.4129C9.77911 2.30621 9.80428 2.18766 9.79892 2.0685C9.79355 1.94935 9.75783 1.83355 9.69514 1.73208C9.63245 1.63061 9.54487 1.54684 9.44071 1.48872C9.33655 1.4306 9.21927 1.40006 9.1 1.4H1.4V0.7C1.4 0.514348 1.32625 0.336301 1.19497 0.205025C1.0637 0.0737498 0.885652 0 0.7 0C0.514348 0 0.336301 0.0737498 0.205025 0.205025C0.0737499 0.336301 0 0.514348 0 0.7V13.3C0 13.4857 0.0737499 13.6637 0.205025 13.795C0.336301 13.9263 0.514348 14 0.7 14C0.885652 14 1.0637 13.9263 1.19497 13.795C1.32625 13.6637 1.4 13.4857 1.4 13.3V8.4H9.1Z"
        fill="#BB0202"
      />
    </svg>
  );
};
